import { PcbNodeTypes } from "@buildwithflux/models";
import { getNodesOfType, getTopLevelFootprints, getTopLevelLayouts, isNodeInTree } from "./traversal";
export function getPcbModelingNodes(pcbLayoutNodes, assets) {
    return {
        footprints: pcbLayoutNodes ? getFootprints(pcbLayoutNodes) : [],
        layouts: pcbLayoutNodes ? getLayouts(pcbLayoutNodes) : [],
        spatial3dModelCount: pcbLayoutNodes ? get3dModelCount(pcbLayoutNodes, assets) : 0,
    };
}
/**
 * @deprecated just use getTopLevelLayouts
 */
export function getLayouts(nodes) {
    if (!nodes)
        return [];
    return getTopLevelLayouts(nodes);
}
/**
 * Get the count of 3d models by inspecting the rules that are set on pcbLayoutNodes of type "model".
 */
export function get3dModelCount(nodes, assets) {
    if (!nodes)
        return 0;
    const modelNodes = getNodesOfType(nodes, PcbNodeTypes.model);
    const result = modelNodes.filter((node) => {
        if (assets == null ||
            node.pcbNodeRuleSet?.asset == null ||
            node.pcbNodeRuleSet?.asset.disabled ||
            node.pcbNodeRuleSet.asset.payloadFileName == null)
            return false;
        // Cross-check that it exists in the assets...
        // TODO: We should just have this live on the document model or something?
        const targetModelForRule = node.pcbNodeRuleSet.asset.payloadFileName;
        return Object.values(assets).some((asset) => asset.storageName === targetModelForRule);
    }).length;
    return result;
}
/**
 * Returns all footprints that should be considered "real" footprints for scoring.
 *
 * QUESTION: what "scoring" does this refer to? Is this idea stale?
 */
export function getFootprints(nodes) {
    // isNodeInTree is necessary here to patch up bad data from when there were orphaned tree nodes.  If it is
    // excluded, orphaned footprints will count towards the score!
    return getTopLevelFootprints(nodes).filter((node) => isNodeInTree(nodes, node.uid));
}
//# sourceMappingURL=data.js.map